import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getThumbGlobalClassNames } from '../../helpers';
var UnknownThumbHtmlView = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames('daeditor-unknown', getThumbGlobalClassNames(deviation)) }, t('deviationview.unknown.nopreview')));
};
UnknownThumbHtmlView.displayName = 'UnknownThumbHtmlView';
export default UnknownThumbHtmlView;
//# sourceMappingURL=UnknownHtml.js.map